import { Alert, Button, Form, FormGroup, FormFeedback, Input, Label, Spinner } from 'reactstrap';
import styles from './ResetPasswordPage.module.scss';
import { useRef, useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useOnChangeHandler } from '../../../global/utils/hooks/useOnChangeHandler';
import { useToggle } from '../../../global/utils/hooks/useToggle';
import { AppContext, UserContext } from '../../../global/globalContext/context';
import { showMsg } from '../../../global/langs/langs';
import { postRequest } from '../../../global/utils/apiCall';

const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@*#$%]).{8,32}$/;
const RESET_PASSwORD = 'api/v1/user/reset-password';

export default function RessetPasswordPage() {
  const { lang } = useContext(UserContext);
  const { setting } = useContext(AppContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  const errorRef = useRef();
  const passwordRef = useRef();

  const [password, setPassword, onChangePassword] = useOnChangeHandler('');
  const [validPassword, setValidPassword] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  
  const [confirmPassword, setConfirmPassword, onChangeHandlerConfirmPassword] = useOnChangeHandler('');
  const [validConfirmPassword, setValidConfirmPassword] = useState(false);

  const [isShowPassword, setIsShoPassword, toggleIsShowPassword] = useToggle(false);

  const [success, setSuccess] = useState(false);
  const [ message, setMessage] = useState('');

  const [token, setToken] = useState(searchParams.get('token') || '');
  const [email, setEmail] = useState(searchParams.get('email') || '');

  useEffect(() => {
    passwordRef.current.focus();
  },[]);

  useEffect(() => {
    setValidPassword(PASSWORD_REGEX.test(password));
    setValidConfirmPassword(password === confirmPassword)
  },[password,confirmPassword]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setSuccess(false);
    setIsLoading(true);
    try {
      const response = await postRequest(RESET_PASSwORD, JSON.stringify({token, email, password, password_confirmation:confirmPassword}));
      setIsLoading(false);
      setSuccess(true);
      setMessage(response?.data?.status);
      setPassword('');
      setConfirmPassword('');
      setTimeout(() => {
        navigate('/login');
      }, 2000);
    }
    catch (error) {
      setIsLoading(false);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
    }
    finally {
      setIsLoading(false);
    }
  }


  return (
    <>
      <div className={`d-flex align-items-center justify-content-center ${styles.loginContainer}`}>
        <div className={`${styles.login} lgtBackground bg-white p-4`}>
          <Alert aria-live="assertive"
              color={success ? 'success' : 'danger'}
              innerRef={errorRef}
              className={message ? `` : `d-none`}
              >
                {message}
          </Alert>
          <Link to='/' className=''>
            {
            setting
              ? <img src={`${`${process.env.REACT_APP_API_URL}${setting.logo
              }`}`} alt="letgo or trade logo" width={'120px'} className={`my-3`}/>
              : ''
            }
          </Link>
          <div className='fw-bold mb-3 '>
            Reset Password
          </div>
          <Form className='mb-3' onSubmit={handleSubmit}>
            <FormGroup floating>
              <Input 
                id ="password"
                className={`${styles.showPassword}`}
                value ={password}
                placeholder ='Password'
                innerRef={passwordRef}
                type = { !isShowPassword ? "password" : "text"}
                required
                onChange ={onChangePassword}
                valid = { password.length > 0 && validPassword ? true : false}
                invalid = { password && !validPassword ? true :false }
                />
                <span className={`${styles.showIcon}`}
                      onClick={toggleIsShowPassword}
                      >
                  <i className={`bi ${!isShowPassword ? "bi-eye" : "bi-eye-slash"}`}></i>
                </span>
                <FormFeedback tooltip>
                    8 to 32 characters.<br />
                    Must include uppercase and lowercase letters, a number and a special character.<br />
                    Allowed special characters: <span aria-label="exclamation mark">!</span> <span aria-label="at symbol">@</span> 
                    <span aria-label="hashtag"> #</span> <span aria-label="dollar sign">$</span> <span aria-label="percent">%</span> <span aria-label="star sign">*</span>
                </FormFeedback>
              <Label>
                Password
              </Label>
            </FormGroup>
            <FormGroup floating className='position-relative'>
              <Input 
                id ="confirmPassword"
                value ={confirmPassword}
                placeholder ='Confirm Password'
                type = { !isShowPassword ? "password" : "text"}
                required
                onChange ={onChangeHandlerConfirmPassword}
                valid = { confirmPassword.length > 0 && validConfirmPassword ? true : false }
                invalid = { confirmPassword && !validConfirmPassword ? true :false }
                />
                <FormFeedback tooltip>
                  Must match the first password input field.
                </FormFeedback>
              <Label>
                Confirm Password
              </Label>
            </FormGroup>
            <Button 
              id='register-btn'
              disabled={ !validPassword || !validConfirmPassword ? true : false }
              block
              className={`general-button fw-semibold largBtn`}
              >
                {
                  isLoading 
                    ? (
                      <>
                        <Spinner size="sm">
                          Loading...
                        </Spinner>
                        <span>
                          {' '}Loading
                        </span>
                      </>
                    )
                    : showMsg('save', lang)
                }
            </Button>
          </Form>
        </div>
      </div>
    </>
  )
}
